import React, { useState, useEffect } from 'react'
import Link from '../../../components/common/Link'
import JoinStep from './JoinStep'
import ShinhanModal from './ShinhanModal'

const JoinStep4 = ({ join, onIdentifyCallback }) => {
  const [shinhanModalOpen, setShinhanModalOpen] = useState(false)

  useEffect(() => {
    window.addEventListener('message', onMessage, false)
    return () => {
      window.removeEventListener('message', onMessage)
    }
  })

  const onMessage = e => {
    if (e.data.type === 'IPIN2' || e.data.type === 'MOBILEM') {
      onIdentifyCallback(e.data.type, e.data.data)
    }
  }

  const [identifyType, setIdentifyType] = useState('MOBILEM')

  const openPhonePopup = () => {
    window.open('/api/v2/user/identify/phone/request', 'mobilem', 'top=10, left=10, width=500, height=600, status=no, menubar=no, toolbar=no, resizable=no')
  }

  const openIpinPopup = () => {
    window.open('/api/v2/user/identify/ipin/request', 'ipin2', 'top=10, left=10, width=500, height=600, status=no, menubar=no, toolbar=no, resizable=no')
  }

  const openShinhanModal = () => {
    setShinhanModalOpen(true)
  }

  const handleShinhanComplete = (resultData, signTxId) => {
    // onIdentifyCallback('SHINHAN', JSON.stringify(resultData))

    const certData = JSON.stringify({
      signTxId: signTxId,
      certTxId: resultData.certTxId,
      // memberId: resultData.memberId,
      status: resultData.status,
      certMethod: 'SHINHAN',
      userCi: resultData.userCi,
      userDi: resultData.userDi,
      userName: resultData.userName,
      userBirth: resultData.userBirth,
      userGender: resultData.userGender,
      userKoreanYn: resultData.userKoreanYn,
      // reqDt: resultData.reqDt,
      // resDt: resultData.resDt,
      // errCode: resultData.errCode,
    })
    onIdentifyCallback('SHINHAN', certData)
  }

  const openIdentifyPopup = () => {
    if (identifyType === 'MOBILEM') {
      openPhonePopup()
    } else if (identifyType === 'IPIN2') {
      openIpinPopup()
    } else if (identifyType === 'SHINHAN') {
      openShinhanModal()
    }
  }

  return (
    <>
      <JoinStep join={join} />
      <div className='content_box sign_up_step3'>
        {/* PC 화면 */}
        <div className='m_invisible'>
          <div className='content_desc'>
            <p>
              다음의 인증 방법 중 하나를 선택해
              <br />
              본인 인증을 해주시기 바랍니다.
            </p>
          </div>

          <div className='link_btn_wrap clearfix'>
            <div className='area area1 float_l'>
              <div className='link_btn link_btn1'>
                <Link onClick={() => openPhonePopup()}>
                  <p>
                    휴대폰
                    <br />
                    인증
                  </p>
                </Link>
              </div>
              <div className='link_btn_desc'> </div>
            </div>
            <div className='area area2 float_l'>
              <div className='link_btn link_btn2'>
                <Link onClick={() => openIpinPopup()}>
                  <p>
                    아이핀
                    <br />
                    인증
                  </p>
                </Link>
              </div>
              <div className='link_btn_desc'> </div>
            </div>
            <div className='area area3 float_r'>
              <div className='link_btn link_btn3'>
                <Link onClick={() => openShinhanModal()}>
                  <p>
                    신한
                    <br />
                    인증서
                  </p>
                </Link>
              </div>
              <div className='link_btn_desc'> </div>
            </div>
          </div>
        </div>

        {/* 모바일 화면 */}
        <div className='pc_invisible'>
          <div className='content_desc'>
            <span>실명인증 방법을 선택해주세요.</span>
          </div>

          <div className='confirm_wrap'>
            <label htmlFor='mobile_confirm' className='mobile_confirm'>
              <input type='radio' id='mobile_confirm' name='name_confirm' value='mobile' checked={identifyType === 'MOBILEM'} onChange={() => setIdentifyType('MOBILEM')} />
              휴대폰(본인 명의)
            </label>
            <label htmlFor='ipin_confirm'>
              <input type='radio' id='ipin_confirm' name='name_confirm' value='ipin' checked={identifyType === 'IPIN2'} onChange={() => setIdentifyType('IPIN2')} />
              아이핀
            </label>
            <label htmlFor='shinhan_confirm'>
              <input type='radio' id='shinhan_confirm' name='name_confirm' value='shinhan' checked={identifyType === 'SHINHAN'} onChange={() => setIdentifyType('SHINHAN')} />
              신한인증서
            </label>
          </div>

          <div className='desc_wrap'>
            <ul>
              <li className='desc1'>본인 명의로 이동 통신사에 가입한 휴대폰으로만 이용 가능합니다.</li>
              <li className='desc1'>소지하고 계신 휴대폰이 본인 명의가 아닌 경우(법인/MVNO 가입자 포함), 아이핀을 선택해 주세요.</li>
            </ul>
            <p className='desc2'>
              [인증 이용문의처]
              <br />
              -NICE 평가정보 : 02-2122-4000
            </p>
          </div>

          <div className='btn_wrap'>
            <button type='submit' className='confirm active' onClick={() => openIdentifyPopup()}>
              확인
            </button>
          </div>
        </div>
      </div>

      {shinhanModalOpen && (
        <ShinhanModal
          mode='join'
          onClose={() => setShinhanModalOpen(false)}
          onComplete={handleShinhanComplete}
        />
      )}
    </>
  )
}

export default JoinStep4
